import { Component, OnInit } from '@angular/core';
import { LeadService } from 'app/platform/lead/lead.service';
import { ProjectService } from 'app/platform/project/project/project.service';
import { LoaderService } from "../../../services/loader.service";
import { environment } from "../../../../environments/environment";
declare var $: any;

@Component({
  selector: "app-designer-dashboard",
  templateUrl: "./designer-dashboard.component.html",
  styleUrls: ["./designer-dashboard.component.css"],
  providers: [ProjectService, LeadService],
})
export class DesignerDashboardComponent implements OnInit {
  constructor(
    private projectService: ProjectService,
    private leadService: LeadService,
    private loaderService: LoaderService
  ) {}

  baseUrl = environment.uihrefUrl;
  public loader: boolean = false;
  public pieChartLabels: string[] = ["On Track", "Delayed"];
  public doughnutChartData: number[];
  public doughnutChartData4: number[];
  public doughnutChartData5: number[];
  public doughnutChartData6: number[];
  public doughnutChartData7: number[];

  public doughnutChartType: string = "doughnut";
  public colors: Array<any> = [
    {
      backgroundColor: ["#8d0528", "#FFEAEF"],
    },
  ];

  public barChartLabels = ["OB", "OC"];
  public barChartType = "bar";
  public barChartLegend = true;
  public barChartData: any[];

  public lineChartColors: Array<any> = [
    {
      backgroundColor: "#FFEAEF",
    },
    {
      backgroundColor: "#8d0528",
    },
  ];

  public barChartLabels2 ;
  public barChartType2 = "bar";
  public barChartLegend2 = true;
  public barChartData2: any[];

  public lineChartColors2: Array<any> = [
    {
      backgroundColor: "#8d0528",
    },
    {
      backgroundColor: "#8d0528",
    },
    {
      backgroundColor: "#8d0528",
    },
    {
      backgroundColor: "#8d0528",
    },
  ];
  // events

  public chartHovered(e: any): void {}

  public canvasWidth = 350;
  public needleValue: any;
  public centralLabel = "";
  public bottomLabel: any;
  public options = {
    hasNeedle: true,
    needleColor: "black",
    needleUpdateSpeed: 1000,
    arcColors: ["#FFEAEF", "#8d0528"],
    arcDelimiters: [30],
    rangeLabel: ["0", "100"],
    needleStartValue: 50,
  };

  public barChartOptions = {
    hover: {
      mode: "nearest",
      intersec: true,
    },
    interaction: {
      mode: "nearest",
    },
  };

  public barChartOptions2 = {
    legend: {
      display: false,
      labels: {
        fontColor: "rgb(255, 99, 132)",
      },
    },
    hover: {
      mode: "nearest",
      intersec: true,
    },
    interaction: {
      mode: "nearest",
    },
    scales: {
      scaleShowValues: true,
      xAxes: [
        {
          ticks: {
            autoSkip: false,
          },

          gridLines: {
            display: false,
          },
          barPercentage: 0.9,
          categoryPercentage: 0.55,
        },
      ],
      yAxes: [
        {
          ticks: {
            min: 0,
            beginAtZero: true,
          },
          gridLines: {
            display: false,
          },
          stacked: true,
        },
      ],
    },
  };

  current_user_id;
  role;

  ngOnInit() {
    this.current_user_id = localStorage.getItem("userId");

    this.getOverallOrderData();
    this.getOverallperformance();
    this.getSiteMeasurementData(1);
    this.getSiteValidationData();
    this.getPaymentStatus();
    this.getSpeedofobtooc();
    this.getCurrentWeekOrder();
    // this.getNextweekOrder();
    this.role = localStorage.getItem("user");
    if (this.role === "business_head") {
      this.getGMList();
    }
    if (this.role === "city_gm") {
      this.getCMList(this.current_user_id);
    }
    if (this.role === "community_manager") {
      this.getDesignerList(this.current_user_id);
    }
  }

  overall_lead_info;
  getOverallperformance() {
    // this.loader=true;
    this.projectService
      .getOverallPerformance(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.overall_lead_info = res.data;
        this.doughnutChartData = [
          this.overall_lead_info.on_track_nocs_count,
          this.overall_lead_info.delayed_nocs_count,
        ];
      });
  }

  order_book_data;
  order_confirm_data;
  getOverallOrderData() {
    this.projectService
      .getOverallorderData(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.order_book_data = res.data.order_booking;
        this.order_confirm_data = res.data.order_confirmation;
        this.barChartData = [
          {
            label: "Order Booking",
            data: [res.data.order_booking],
          },
          {
            label: "Order Confirmation",
            data: [res.data.order_confirmation],
          },
        ];
      });
  }

  current_week_value;
  current_week_label;
  current_week_data;
  getCurrentWeekOrder() {
    this.loader = true;
    this.projectService
      .getcurrentweekorder(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.current_week_value = Object.values(res)[0];
        this.current_week_label = Object.keys(res)[0];
        this.current_week_data = res.quotations;
        this.getNextweekOrder();
        this.loader = false;
      });
  }

  week1;
  week1_label;
  week1_data;
  week2;
  week2_label;
  week2_data;
  week3;
  week3_label;
  week3_data;
  week4;
  week4_label;
  week4_data;
  week5;
  week5_label;
  week5_data;
  getNextweekOrder() {
    this.loader = true;
    this.projectService
      .getnexttweekorder(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.week1 = Object.values(res.data[0])[0];
        this.week1_label = Object.keys(res.data[0])[0];
        this.week1_data = res.data[0].quotations;
        this.week2 = Object.values(res.data[1])[0];
        this.week2_label = Object.keys(res.data[1])[0];
        this.week2_data = res.data[1].quotations;
        this.week3 = Object.values(res.data[2])[0];
        this.week3_label = Object.keys(res.data[2])[0];
        this.week3_data = res.data[2].quotations;
        this.week4 = Object.values(res.data[3])[0];
        this.week4_label = Object.keys(res.data[3])[0];
        this.week4_data = res.data[3].quotations;
        this.week5 = Object.values(res.data[4])[0];
        this.week5_label = Object.keys(res.data[4])[0];
        this.week5_data = res.data[4].quotations;
        this.loader = false;
        this.getValueWeekvise();
      });
  }

  getValueWeekvise() {
    this.barChartData2 = [
      {
        data: [
          Math.round(this.current_week_value),
          Math.round(this.week1),
          Math.round(this.week2),
          Math.round(this.week3),
          Math.round(this.week4),
          Math.round(this.week5)
        ],
        // stack: 1
      },
    this.barChartLabels2  = ['W'+this.current_week_label,'W'+this.week1_label,'W'+this.week2_label,'W'+this.week3_label,'W'+this.week4_label,'W'+this.week5_label]
      // {
      //   data: this.week1,
      //   stack: 2
      // },
    ];
  }

  payment_status_info;
  percentage_delayed;
  getPaymentStatus() {
    this.loaderService.display(true);
    this.projectService
      .getpaymentStatusData(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.payment_status_info = res.data;
        this.doughnutChartData7 = [
          this.payment_status_info.payment_status.on_track.length,
          this.payment_status_info.payment_status.delayed.length,
        ];
        this.percentage_delayed = res.percentage_delayed;
        this.loaderService.display(false);
      });
  }

  site_measure_data;
  current_page: any = 1;
  per_page: any = 10;
  per_page2: any = 10;
  total_page;
  total_page2;
  current_page2: any = 1;
  headers_res;
  getSiteMeasurementData(pageno: any) {
    this.loaderService.display(true);
    this.projectService
      .getsitemeasurementData(
        pageno,
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.headers_res = res.headers._headers;
        this.total_page = this.headers_res.get("x-total");
        this.current_page = pageno;
        this.per_page = 5;
        res = res.json();
        this.site_measure_data = res.data;
        this.loaderService.display(false);
      });
  }

  pageChanged(event) {
    this.current_page2 = event;
    // this.total_page2 = this.overall_lead_info.on_track_nocs.length;
    this.per_page2 = 10;
  }

  site_validation_info;
  getSiteValidationData() {
    this.loaderService.display(true);
    this.projectService
      .getsitevalidationData(
        this.gms,
        this.cms,
        this.designerss,
        this.from_date,
        this.to_date
      )
      .subscribe((res) => {
        this.site_validation_info = res.data;
        this.doughnutChartData4 = [
          this.site_validation_info.site_validation.on_track.length,
          this.site_validation_info.site_validation.delayed.length,
        ];
        this.doughnutChartData5 = [
          this.site_validation_info.qc_submit.on_track.length,
          this.site_validation_info.qc_submit.delayed.length,
        ];
        this.doughnutChartData6 = [
          this.site_validation_info.qc_approval.on_track.length,
          this.site_validation_info.qc_approval.delayed.length,
        ];
        this.loaderService.display(false);
      });
  }

  getSpeedofobtooc() {
    this.loaderService.display(true);
    this.projectService.getspeedofobtooc().subscribe((res) => {
      this.bottomLabel = res.data;
      this.needleValue = res.data;
      this.loaderService.display(false);
    });
  }

  show_value: boolean = false;
  show_book: boolean = false;
  show_confirm: boolean = false;
  display_val1;
  display_val2;

  chartClickeing(e) {
    this.boq_reference = false;
    this.show_value = true;
    if (e.active[0]._datasetIndex == 0) {
      this.show_book = true;
      this.show_confirm = false;
      this.display_val1 = this.order_book_data;
    }
    if (e.active[0]._datasetIndex == 1) {
      this.show_confirm = true;
      this.show_book = false;
      this.display_val2 = this.order_confirm_data;
    }
  }

  overall_info_table: any;
  header_name;
  public chartClicked(e: any): void {
    this.boq_reference = false;
    if (e.active[0]._index == 0) {
      this.quotation_delayed = false;
      this.header_name = "On Track Leads";
      this.overall_info_table = this.overall_lead_info.on_track_nocs;
      this.total_page2 = this.overall_lead_info.on_track_nocs.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
      // this.pageChanged(1);
    } else if (e.active[0]._index == 1) {
      this.quotation_delayed = false;
      this.header_name = "Delayed Leads";
      this.overall_info_table = this.overall_lead_info.delayed_nocs;
      this.total_page2 = this.overall_lead_info.delayed_nocs.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
    $("#onTrackModal").modal("show");
  }

  // overall_info_table: any;
  // header_name;
  public chartClicked4(e: any): void {
    this.boq_reference = false;
    if (e.active[0]._index == 0) {
      this.quotation_delayed = false;
      this.header_name = "On Track Leads";
      this.overall_info_table =
        this.site_validation_info.site_validation.on_track;
      this.total_page2 =
        this.site_validation_info.site_validation.on_track.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    } else if (e.active[0]._index == 1) {
      this.quotation_delayed = false;
      this.header_name = "Delayed Leads";
      this.overall_info_table =
        this.site_validation_info.site_validation.delayed;
      this.total_page2 =
        this.site_validation_info.site_validation.delayed.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
    $("#onTrackModal").modal("show");
  }
  public chartClicked5(e: any): void {
    this.boq_reference = false;
    if (e.active[0]._index == 0) {
      this.quotation_delayed = false;
      this.header_name = "On Track Leads";
      this.overall_info_table = this.site_validation_info.qc_submit.on_track;
      this.total_page2 = this.site_validation_info.qc_submit.on_track.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    } else if (e.active[0]._index == 1) {
      this.quotation_delayed = false;
      this.header_name = "Delayed Leads";
      this.overall_info_table = this.site_validation_info.qc_submit.delayed;
      this.total_page2 = this.site_validation_info.qc_submit.delayed.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
    $("#onTrackModal").modal("show");
  }

  public chartClicked6(e: any): void {
    this.boq_reference = false;
    if (e.active[0]._index == 0) {
      this.quotation_delayed = false;
      this.header_name = "On Track Leads";
      this.overall_info_table = this.site_validation_info.qc_approval.on_track;
      this.total_page2 = this.site_validation_info.qc_approval.on_track.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    } else if (e.active[0]._index == 1) {
      this.quotation_delayed = false;
      this.header_name = "Delayed Leads";
      this.overall_info_table = this.site_validation_info.qc_approval.delayed;
      this.total_page2 = this.site_validation_info.qc_approval.delayed.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
    $("#onTrackModal").modal("show");
  }

  quotation_delayed : boolean = false;
  public chartClicked7(e: any): void {
    this.boq_reference = false;
    if (e.active[0]._index == 0) {
      this.quotation_delayed = false;
      this.header_name = "On Track Leads";
      this.overall_info_table =
        this.payment_status_info.payment_status.on_track;
      this.total_page2 =
        this.payment_status_info.payment_status.on_track.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    } else if (e.active[0]._index == 1) {
      this.quotation_delayed = true;
      this.header_name = "Delayed Leads";
      this.overall_info_table = this.payment_status_info.payment_status.delayed;
      this.total_page2 = this.payment_status_info.payment_status.delayed.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
    $("#onTrackModal").modal("show");
  }

  boq_reference: boolean = false;
  public chartClicked9(e: any) {
    this.boq_reference = true;
    if(e.active[0]._index === 0){
      this.header_name = "On Track Leads";
      this.overall_info_table = this.current_week_data;
      this.total_page2 = this.current_week_data.length;
      this.current_page2 = 1;
      this.per_page2 = 10;
    }
     if (e.active[0]._index === 1) {
       this.header_name = "On Track Leads";
       this.overall_info_table = this.week1_data;
       this.total_page2 = this.week1_data.length;
       this.current_page2 = 1;
       this.per_page2 = 10;
     }
      if (e.active[0]._index === 2) {
        this.header_name = "On Track Leads";
        this.overall_info_table = this.week2_data;
        this.total_page2 = this.week2_data.length;
        this.current_page2 = 1;
        this.per_page2 = 10;
      }
       if (e.active[0]._index === 3) {
         this.header_name = "On Track Leads";
         this.overall_info_table = this.week3_data;
         this.total_page2 = this.week3_data.length;
         this.current_page2 = 1;
         this.per_page2 = 10;
       }
        if (e.active[0]._index === 4) {
          this.header_name = "On Track Leads";
          this.overall_info_table = this.week4_data;
          this.total_page2 = this.week4_data.length;
          this.current_page2 = 1;
          this.per_page2 = 10;
        }
         if (e.active[0]._index === 5) {
           this.header_name = "On Track Leads";
           this.overall_info_table = this.week5_data;
           this.total_page2 = this.week5_data.length;
           this.current_page2 = 1;
           this.per_page2 = 10;
         }
    $("#onTrackModal").modal("show");
  }

  general_manager: any = [];
  getGMList() {
    this.loaderService.display(true);
    this.leadService.getGMList(this.current_user_id).subscribe((res) => {
      this.general_manager = res.gms_list;
      this.loaderService.display(false);
    });
  }

  gms: any = "";
  onItemSelect(items) {
    if (items === undefined) {
      this.gms = "";
      // this.cms = ''
      // this.designerss = ''
      this.community_manager = [];
      this.designer = [];
    } else {
      this.gms = items;
      this.getCMList(this.gms);
    }

    this.getOverallperformance();
    this.getOverallOrderData();
    this.getSiteMeasurementData(1);
    this.getSiteValidationData();
    this.getCurrentWeekOrder();
    this.getPaymentStatus();
  }

  cms: any = "";
  onItemSelect2(items) {
    if (items === undefined) {
      this.cms = "";
      // this.cms = ''
      // this.designerss = ''
      this.designer = [];
    } else {
      this.cms = items;
      this.getDesignerList(this.cms);
    }
    this.getOverallperformance();
    this.getOverallOrderData();
    this.getSiteMeasurementData(1);
    this.getSiteValidationData();
    this.getCurrentWeekOrder();
    this.getPaymentStatus();
    // this.getNextweekOrder();
  }

  designerss: any = "";
  onItemSelect3(items) {
    if (items === undefined) {
      this.designerss = "";
      // this.cms = ''
      // this.designerss = ''
    } else {
      this.designerss = items;
    }
    this.getOverallperformance();
    this.getOverallOrderData();
    this.getSiteMeasurementData(1);
    this.getSiteValidationData();
    this.getCurrentWeekOrder();
    this.getPaymentStatus();
    // this.getNextweekOrder();
  }

  designer;
  getDesignerList(id) {
    this.loaderService.display(true);
    this.leadService
      .getDesignerListNOC(this.current_user_id, id)
      .subscribe((res) => {
        this.designer = res.designers_list;
        this.loaderService.display(false);
      });
  }

  gmlist;
  community_manager;
  getCMList(id: any) {
    this.loaderService.display(true);
    this.gmlist = id;
    this.leadService
      .getCMList(this.current_user_id, this.gmlist)
      .subscribe((res) => {
        this.community_manager = res.cms_list;
        this.loaderService.display(false);
      });
  }

  from_date: any;
  to_date: any;
  changeDateFrom(event: any) {
    this.from_date = event;
  }

  changeDateTo(event: any) {
    this.to_date = event;
  }

  date;
  delayed_data = 'curr';
  select_prev(e: any) {
    if (e === "prev") {
      this.delayed_data = 'prev';
      this.date = new Date();
      var prevMonthLastDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth(),
        0
      );
      var prevMonthFirstDate = new Date(
        this.date.getFullYear() - (this.date.getMonth() > 0 ? 0 : 1),
        (this.date.getMonth() - 1 + 12) % 12,
        1
      );
      this.from_date = prevMonthFirstDate;
      this.to_date = prevMonthLastDate;
      this.getOverallperformance();
      this.getOverallOrderData();
      this.getSiteMeasurementData(1);
      this.getSiteValidationData();
      this.getPaymentStatus();
      this.getCurrentWeekOrder();
    }
    if (e === "curr") {
      this.delayed_data = "curr";
      this.from_date = "";
      this.to_date = "";
      this.getOverallperformance();
      this.getOverallOrderData();
      this.getSiteMeasurementData(1);
      this.getSiteValidationData();
      this.getPaymentStatus();
      this.getCurrentWeekOrder();
    }
  }

  filterDashboard() {
    this.getOverallperformance();
    this.getOverallOrderData();
    this.getSiteMeasurementData(1);
    this.getSiteValidationData();
    this.getPaymentStatus();
    this.getCurrentWeekOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/platform/customer/designer-dashboard/designer-dashboard.component.ts